/* unplugin-vue-components disabled */import { render } from "./multiBarChart.vue?vue&type=template&id=cdc85f12"
import script from "./multiBarChart.vue?vue&type=script&lang=js"
export * from "./multiBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__